import * as React from 'react';
import { withStyles, StyleRulesCallback, WithStyles } from '@material-ui/core/styles';
import { RouteComponentProps, withRouter } from 'react-router';
import { Typography } from '@material-ui/core';
import { Button } from '@material-ui/core';
import { Paper } from '@material-ui/core';


interface Props {
  headline: string,
  content: string,
  button: string
}

type LocalStyles = 'root' | 'button';

const localStyles: StyleRulesCallback<LocalStyles> = theme => ({
  root: {
    textAlign: 'center',
    padding: theme.spacing.unit * 2,
  },
  button: {
    marginTop: theme.spacing.unit * 4,
  },
});

type PropsWithStyle = WithStyles<LocalStyles> & RouteComponentProps & Props;

class ErrorPage extends React.Component<PropsWithStyle, {}> {

  public render() {
    return (
      <Paper elevation={1}>
        <div className={this.props.classes.root}>
          <Typography variant="h4">
            {this.props.headline}
          </Typography>
          <br/>
          <Typography variant="body1">
            {this.props.content}
          </Typography>

          <Button className={this.props.classes.button} onClick={() => this.props.history.push('/')}>
            {this.props.button}
          </Button>
        </div>
      </Paper>
    );
  }

}

export default withRouter(withStyles(localStyles)(ErrorPage));
